
  
  class SocialShare extends HTMLElement {
    constructor() {
        super();
        this.init();
    }
    init() {
        this.querySelectorAll('.btn-sharing').forEach(share => {
            share.addEventListener("click", event => {
              const url = event.currentTarget.getAttribute('href');
              if (!url) return;
              // Pass ONLY the share URL; popup features go in the 3rd argument.
              const popup = window.open(url, 'stav-share', 'toolbar=0,status=0,width=660,height=445');
              if (popup) {
                popup.opener = null;
                event.preventDefault();
              }
              // Popup blocked: the link's own href + target=_blank still opens the share page.
            }, false);
        });
    }
  }
  customElements.define("social-share", SocialShare);
  